import { render, staticRenderFns } from "./divEditor.vue?vue&type=template&id=12c395b8&"
import script from "./divEditor.vue?vue&type=script&lang=js&"
export * from "./divEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/common/divEditor.vue"
export default component.exports